export class AuthError extends Error {
  code: string;
  constructor(code: string, message: string) {
    super(message);
    this.code = code;
  }
}

export function mapFirebaseAuthError(error: unknown): AuthError {
  const code =
    error && typeof error === 'object' && 'code' in error
      ? String((error as { code: string }).code)
      : '';
  const message =
    error && typeof error === 'object' && 'message' in error
      ? String((error as { message: string }).message)
      : '';

  switch (code) {
    case 'auth/requires-recent-login':
      return new AuthError(
        'requires_recent_login',
        'Please confirm your identity and try again.',
      );
    case 'auth/email-already-in-use':
      return new AuthError('email_in_use', 'Email already registered');
    case 'auth/invalid-email':
      return new AuthError('invalid_credentials', 'Invalid email or password');
    case 'auth/invalid-credential':
    case 'auth/wrong-password':
    case 'auth/user-not-found':
    case 'auth/invalid-login-credentials':
      return new AuthError('invalid_credentials', 'Invalid email or password');
    case 'auth/weak-password':
      return new AuthError('weak_password', 'Password is too weak');
    case 'auth/expired-action-code':
    case 'auth/invalid-action-code':
      return new AuthError('invalid_token', 'Invalid or expired link');
    case 'auth/network-request-failed':
      return new AuthError('network', 'Network error. Check your connection.');
    case 'auth/too-many-requests':
      return new AuthError('rate_limited', 'Too many attempts. Try again later.');
    case 'auth/operation-not-allowed':
      return new AuthError(
        'not_allowed',
        'This sign-in method is not enabled in Firebase.',
      );
    case 'auth/popup-closed-by-user':
    case 'auth/cancelled-popup-request':
      return new AuthError('popup_closed', 'Sign-in was cancelled');
    case 'auth/popup-blocked':
      return new AuthError(
        'popup_blocked',
        'Pop-up was blocked. Allow pop-ups and try again.',
      );
    case 'auth/account-exists-with-different-credential':
      return new AuthError(
        'account_exists',
        'An account already exists with this email using a different sign-in method.',
      );
    case 'permission-denied':
      return new AuthError(
        'permission_denied',
        'Firestore permission denied. Publish security rules for users/{uid}.',
      );
    default:
      return new AuthError(
        code || 'unknown',
        message || `Authentication failed${code ? ` (${code})` : ''}`,
      );
  }
}
